import {
  Box,
  Typography,
  Pagination as MuiPagination,
  Select,
  MenuItem,
  FormControl,
} from '@mui/material';
import useCommonMediaQuery from '../../hooks/useCommonMediaQuery';

const Pagination = ({
  currentPage,
  totalPages,
  totalElements,
  pageSize,
  onPageChange,
  onPageSizeChange,
  loading = false,
  disabled = false,
  menuZIndex,
}) => {
  const startEntry = currentPage * pageSize + 1;
  const endEntry = Math.min((currentPage + 1) * pageSize, totalElements);
  const isMobile = useCommonMediaQuery('sm');

  const handlePageChange = (_, page) => {
    if (!loading && !disabled) {
      onPageChange(page - 1);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: 'space-between',
        alignItems: { xs: 'flex-start', md: 'center' },
        gap: { xs: 2, md: 1.5 },
        mt: 1.5,
        pt: 2,
        borderTop: '1px solid #f3f4f6',
        px: { xs: 0, sm: 1 },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          overflowX: 'auto',
          pb: 0.25,
        }}
      >
        <MuiPagination
          count={totalPages}
          page={currentPage + 1}
          onChange={handlePageChange}
          siblingCount={isMobile ? 0 : 1}
          boundaryCount={isMobile ? 1 : 2}
          variant="outlined"
          shape="rounded"
          disabled={loading || disabled}
          sx={{
            '& .MuiPagination-ul': {
              flexWrap: 'nowrap',
              gap: '8px',
            },
            '& .MuiPaginationItem-root': {
              margin: 0,
              border: '1px solid #D0D5DD',
              color: '#344054',
              fontWeight: 500,
              backgroundColor: '#F8FAFC',
              '&:hover': {
                backgroundColor: '#EEF2F6',
              },
              '&.Mui-selected': {
                backgroundColor: '#0D213B',
                color: '#ffffff',
              },
              '&.MuiPaginationItem-ellipsis': {
                borderColor: 'transparent',
                backgroundColor: 'transparent',
              },
            },
          }}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: { xs: 'center', sm: 'center' },
          justifyContent: { xs: 'space-between', sm: 'center', md: 'end' },
          flexWrap: { xs: 'wrap', sm: 'nowrap' },
          width: '100%',
          gap: 1.5,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: '#6b7280',
            fontSize: '0.875rem',
            whiteSpace: 'nowrap',
          }}
        >
          Showing {startEntry} to {endEntry} of {totalElements} entries
        </Typography>
        <FormControl
          size="small"
          sx={{
            minWidth: 130,
            ml: { xs: 0, sm: 'auto', md: 0 },
          }}
        >
          <Select
            value={pageSize}
            onChange={e => onPageSizeChange(e.target.value)}
            disabled={loading || disabled}
            MenuProps={
              menuZIndex != null
                ? {
                    sx: {
                      '&.MuiPopover-root': {
                        zIndex: `${menuZIndex} !important`,
                      },
                    },
                  }
                : undefined
            }
            sx={{
              height: 40,
              fontSize: '0.875rem',
              borderRadius: '12px',
              color: '#344054',
              '& .MuiSelect-select': {
                py: 1,
                px: 1.5,
              },
            }}
          >
            <MenuItem value={10}>Show 10</MenuItem>
            <MenuItem value={25}>Show 25</MenuItem>
            <MenuItem value={50}>Show 50</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

export default Pagination;
